/* =========================================================
   SPONSORS MARQUEE — JS
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.sponsors-marquee__track');
  if (!track) return;

  // Accesibilidad: reduce motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    track.style.animationPlayState = 'paused';
  }
});
